import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";
import AddPipeFittingModal from "../Pipes/AddPipeFittingModal";

function AddHangerModal({
  isOpen,
  onClose,
  trade,
  submittalId,
  onSuccess,
  editData,
}) {
  const [formData, setFormData] = useState({
    material: "",
    specification: "",
    insulation: false,
    maxSize: "",
    hangerProduct: "",
    shieldProduct: "",
    notes: "",
  });
  const [allSizes, setAllSizes] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [hangerProducts, setHangerProducts] = useState([]);
  const [shieldProducts, setShieldProducts] = useState([]);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          sizesResponse,
          materialsResponse,
          hangerProductsResponse,
          shieldProductsResponse,
        ] = await Promise.all([
          apiClient.get("/sizes"),
          apiClient.get("/materials"),
          apiClient.get(
            "/products?product_type_id=7dc4a4eb-e0fa-401a-bbbe-56acc75a685c"
          ),
          apiClient.get(
            "/products?product_type_id=236597a9-409e-4abe-a525-0a0f9ac4a731"
          ),
        ]);

        // setAllSizes(sizesResponse);
        // setMaterials(materialsResponse);
          // setHangerProducts(hangerProductsResponse);
          // setShieldProducts(shieldProductsResponse);
        // this will change once we update materials
        setAllSizes(sizesResponse?.data || []);
        setMaterials(materialsResponse?.data || []);
        // console.log("hangerProductsResponse", hangerProductsResponse);
        // console.log("shieldProductsResponse", shieldProductsResponse);
        setHangerProducts(hangerProductsResponse?.data || []);
        setShieldProducts(shieldProductsResponse?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Set empty arrays as fallback to prevent undefined errors
        setAllSizes([]);
        setMaterials([]);
        setHangerProducts([]);
        setShieldProducts([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      editData &&
      materials.length > 0 &&
      allSizes.length > 0 &&
      hangerProducts.length > 0 &&
      shieldProducts.length > 0
    ) {
      console.log("Setting form data for edit:", editData);
      console.log(
        "Available materials:",
        materials.map((m) => m.name)
      );
      console.log(
        "Available sizes:",
        allSizes.map((s) => s.size)
      );
      console.log(
        "Available hanger products:",
        hangerProducts.map((p) => p.name)
      );
      console.log(
        "Available shield products:",
        shieldProducts.map((p) => p.name)
      );

      setFormData({
        material: editData.material || "",
        specification: editData.specification || "",
        insulation: editData.insulation || false,
        maxSize: editData.max_size || "",
        hangerProduct: editData.hanger_product || "",
        shieldProduct: editData.shield_product || "",
        notes: editData.notes || "",
      });
    } else if (!editData) {
      // Reset form for new entries
      setFormData({
        material: "",
        specification: "",
        insulation: false,
        maxSize: "",
        hangerProduct: "",
        shieldProduct: "",
        notes: "",
      });
    }
  }, [editData, isOpen, materials, allSizes, hangerProducts, shieldProducts]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that submittalId is provided
    if (!submittalId) {
      alert("Error: No submittal ID provided. Cannot save hanger.");
      console.error("submittalId is missing:", submittalId);
      return;
    }

    console.log("Submitting with submittalId:", submittalId);

    try {
      const result = editData
        ? await apiClient.put(`/hangers/${editData.id}`, {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            insulation: formData.insulation,
            max_size: formData.maxSize,
            hanger_product: formData.hangerProduct,
            shield_product: formData.shieldProduct,
            notes: formData.notes,
            trade: trade,
          })
        : await apiClient.post("/hangers", {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            insulation: formData.insulation,
            max_size: formData.maxSize,
            hanger_product: formData.hangerProduct,
            shield_product: formData.shieldProduct,
            notes: formData.notes,
            trade: trade,
          });

              const responseData = result.data;
        
        if (result && result.success) {
        console.log(
          `Hanger ${editData ? "updated" : "saved"} successfully:`,
          responseData
        );
        // Close modal and reset form
        onClose();
        setFormData({
          material: "",
          specification: "",
          insulation: false,
          maxSize: "",
          hangerProduct: "",
          shieldProduct: "",
          notes: "",
        });
        // Call onSuccess callback to refresh the parent component
        if (onSuccess) {
          onSuccess();
        }
      } else {
        console.error(
          `Error ${editData ? "updating" : "saving"} hanger:`,
          result
        );
        alert(`Error ${editData ? "updating" : "saving"} hanger: ` + result);
      }
    } catch (error) {
      console.error(`Error submitting hanger data:`, error);
      alert(`Error submitting hanger data. Please try again.`);
    }
  };

  const refreshProducts = async () => {
    try {
      const [hangerProductsResponse, shieldProductsResponse] =
        await Promise.all([
          apiClient.get(
            "/products?product_type_id=7dc4a4eb-e0fa-401a-bbbe-56acc75a685c"
          ),
          apiClient.get(
            "/products?product_type_id=236597a9-409e-4abe-a525-0a0f9ac4a731"
          ),
        ]);

        // setHangerProducts(hangerProductsResponse);
        // setShieldProducts(shieldProductsResponse);
        // this will change once we update products
        setHangerProducts(hangerProductsResponse.data);
        setShieldProducts(shieldProductsResponse.data);
    } catch (error) {
      console.error("Error refreshing products:", error);
    }
  };

  const openAddProductModal = () => {
    setIsAddProductModalOpen(true);
  };

  const closeAddProductModal = () => {
    setIsAddProductModalOpen(false);
    refreshProducts(); // Refresh products when modal closes
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">
            {editData ? "Edit Hanger" : "Add Hanger"}
          </h2>
          <div className="flex items-center space-x-3">
            <button
              type="button"
              onClick={openAddProductModal}
              className="px-2 py-1 text-xs font-medium text-green-600 border border-green-600 rounded hover:bg-green-50"
            >
              Add Product
            </button>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Material
            </label>
            <select
              name="material"
              value={formData.material}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Material</option>
              {Array.isArray(materials) && materials.map((material) => (
                <option key={material.id} value={material.name}>
                  {material.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="insulation"
              id="insulation"
              checked={formData.insulation}
              onChange={handleInputChange}
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
            />
            <label htmlFor="insulation" className="ml-2 text-sm text-gray-700">
              Insulated
            </label>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Max Size
            </label>
            <select
              name="maxSize"
              value={formData.maxSize}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Size</option>
              {Array.isArray(allSizes) && allSizes.map((size) => (
                <option key={size.id} value={size.size}>
                  {size.size}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Hanger
            </label>
            <select
              name="hangerProduct"
              value={formData.hangerProduct}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Hanger Product</option>
              {Array.isArray(hangerProducts) && hangerProducts.map((product) => (
                <option key={product.id} value={product.name}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Shield/Accessory
            </label>
            <select
              name="shieldProduct"
              value={formData.shieldProduct}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Shield/Accessory</option>
              {Array.isArray(shieldProducts) && shieldProducts.map((product) => (
                <option key={product.id} value={product.name}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notes
            </label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter notes"
            />
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
            >
              {editData ? "Update Hanger" : "Add Hanger"}
            </button>
          </div>
        </form>
      </div>

      {/* Add Product Modal */}
              <AddPipeFittingModal
          isOpen={isAddProductModalOpen}
          onClose={closeAddProductModal}
        />
    </div>
  );
}

export default AddHangerModal;
